/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Process_Step_Trial_BalanceInputs */

const en_input_process_step_trial_balance = /** @type {(inputs: Input_Process_Step_Trial_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial balance`)
};

const nl_input_process_step_trial_balance = /** @type {(inputs: Input_Process_Step_Trial_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proefbalans`)
};

/**
* | output |
* | --- |
* | "Trial balance" |
*
* @param {Input_Process_Step_Trial_BalanceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const input_process_step_trial_balance = /** @type {((inputs?: Input_Process_Step_Trial_BalanceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Process_Step_Trial_BalanceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_input_process_step_trial_balance(inputs)
	return en_input_process_step_trial_balance(inputs)
});